exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-card--app__avatar[data-v-7e3cf2f0]{position:relative;top:-64px;margin-bottom:-32px}.v-card--app__heading[data-v-7e3cf2f0]{top:-5px}.v-card--app__heading[data-v-7e3cf2f0],.v-card--app__heading-2[data-v-7e3cf2f0]{position:relative;transition:.3s ease;z-index:1}.v-card--app__heading-2[data-v-7e3cf2f0]{top:-15px}.v-sheet[data-v-7e3cf2f0]{border-radius:4px}", ""]);

// exports
